<template>
	<div>
		<div class="box">
			<div class="first" @click="click(item.id)"  v-for="(item,index) in list" :key="index">
				<div :class="selectId == item.id ? 'blue first-name item' : 'first-name item'">
					<div>{{item.name}}</div>
					<div><i class="iconfont ficon-right"></i></div>
				</div>
				<div class="second"  @click.stop="click(items.id,2)"  v-if="selectId == item.id"  v-for="(items,i) in item.children" :key="i">
					<div :class="selectIds == items.id ? 'blue second-name item' : 'second-name item'"  style="padding-left:70px ;">
						<div>{{items.name}}</div>
						<div><i class="iconfont ficon-right"></i></div>
					</div>
					<div class="last" v-if="selectIds == items.id">
						<div v-for="(litem,j) in items.children" @click.stop="clickType(litem.id)" :key="j">{{litem.name}}</div>
					</div>
				</div>
			</div>

		</div>

	</div>
</template>
<script>
	import {category,lists} from '@/api/index.js'
	export default{
		data(){
			return{
				selectId:'-1',
				selectIds:'-1',
				list:[]
			}
		},
		methods:{
			click(e,i){
				if(i == 2){
					if(e == this.selectIds){
						this.selectIds = -1
					}else{
						this.selectIds = e
					}
				}else{
					if(e == this.selectId){
						this.selectId = -1
					}else{
						this.selectId = e
					}
				}
				event.stopPropagation();
			},
			clickType(e){
				this.$emit('clickType',e)
			}
		},
		props:{

		},
		watch:{

		},
		created() {

			category().then(res=>{
                console.log(res)
				this.list = res.data.children

			});
		}
	}
</script>
<style lang="less" scoped>
	.box{
		width: 211px;
		// height: 300px;
		background: #FFFFFF;
		border-radius: 8px;
		border: 1px solid #0097FE;
		.first{
			.first-name{
				border-bottom: solid 1px #999;
			}
		}
		.last{
			div {
				text-align: center;
				height: 40px;
				line-height: 40px;
                cursor: pointer;
			}

		}

	}
	.item{
		display: flex;
		justify-content: space-between;
		padding: 0 10px 0 60px;
		height: 40px;
		align-items: center;
		border-bottom: solid 1px #999;
        cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/select.vue